export default class GeoModel {
  constructor(dataJson) {
    this.dataJson = dataJson;
    if (typeof dataJson === 'undefined') {
      this.dataJson = {};
    }
  }

  get data() {
    return this.dataJson.data;
  }

  get timestamp() {
    return this.dataJson.timestamp;
  }

  get iso() {
    return this.dataJson.iso;
  }

  get gb() {
    return this.dataJson.gb;
  }

  get geo() {
    return this.dataJson;
  }
}
